import { useDocumentSnapshot } from '../../../../../firebase/firestore/hooks';
import { Collections } from '../../../../../firebase/firestore/collections';
import { Position } from '../../../../../firebase/firestore/documents/position';

export const usePositionDocumentSnapshot = (positionId?: string): Readonly<Position> | undefined => {
  return useDocumentSnapshot<Readonly<Position>>(Collections.POSITIONS, positionId);
};
